
import { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '錏設工程行提供哪些噴砂噴漆服務？',
      answer: '我們提供全方位的噴砂噴漆服務，包括金屬表面除鏽、防鏽處理、高品質粉刷、工業設備維護、公共工程承攬等。適用於各種工業設施、商業建築和公共基礎設施。'
    },
    {
      question: '工程承攬的施工流程是什麼？',
      answer: '我們的施工流程包括：現場勘查評估、詳細規劃設計、材料準備、表面預處理、噴砂除鏽、防鏽底漆、面漆施工、品質檢驗、完工驗收。每個步驟都有嚴格的品質控管。'
    },
    {
      question: '噴砂噴漆工程需要多長時間完成？',
      answer: '施工時間依據工程規模而定。小型設備維護通常1-3天，中型工程約1-2週，大型工程專案可能需要1-3個月。我們會在評估後提供詳細的時程規劃。'
    },
    {
      question: '你們使用什麼材料和設備？',
      answer: '我們使用最新的噴砂與噴漆設備，採用高品質的防鏽漆料和保護塗料。所有材料都符合工業標準，設備定期維護保養，確保施工品質和安全性。'
    },
    {
      question: '工程完成後有保固嗎？',
      answer: '是的，我們對所有工程提供保固服務。保固期間依據工程類型和使用環境而定，一般為1-3年。保固期內如有品質問題，我們會免費維修處理。'
    },
    {
      question: '如何獲得工程報價？',
      answer: '您可以透過電話、電子郵件或線上表單聯絡我們。我們會安排專業人員到現場勘查，根據實際需求提供詳細的報價單，包含材料、工時和施工方案。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            常見問題
          </h2>
          <p className="text-xl text-gray-600">
            關於<strong>噴砂噴漆</strong>與<strong>工程承攬</strong>服務的常見問題解答
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left bg-white hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </h3>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-teal-600 text-xl flex-shrink-0`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 bg-gray-50">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">還有其他問題嗎？</p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            線上諮詢
          </button>
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
};

export default FAQSection;
